import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';

import { AuthService } from './auth.service';
import { Observable } from 'rxjs/Observable';
import { switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import * as firebase from 'firebase/app';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    auth: AuthService;
    bypass_list = ['oauthCallback', 'getSubscriptionPlans/', 'rsvp'];

    constructor(private inj: Injector) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (this.bypass_list.indexOf(request.url.replace(environment.functionsURL + '/', '')) > -1) {
            return next.handle(request) 
        }

        this.auth = this.inj.get(AuthService); // inject the authservice manually (see https://github.com/angular/angular/issues/18224)

        return this.auth.getUserIdToken().pipe(
            switchMap(token => {
                 request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`
                    }
                });
                 return next.handle(request);
            })
        )
    }
}


// WEBPACK FOOTER //
// ./src/app/core/token.interceptor.ts